import { render } from "./AggiungiLavori.vue?vue&type=template&id=25f2ab4d&scoped=true"
import script from "./AggiungiLavori.vue?vue&type=script&lang=js"
export * from "./AggiungiLavori.vue?vue&type=script&lang=js"

import "./AggiungiLavori.vue?vue&type=style&index=0&id=25f2ab4d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f2ab4d"]])

export default __exports__